import { render } from "./StylistVote.vue?vue&type=template&id=3fafd772&scoped=true"
import script from "./StylistVote.vue?vue&type=script&lang=js"
export * from "./StylistVote.vue?vue&type=script&lang=js"

import "./StylistVote.vue?vue&type=style&index=0&id=3fafd772&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fafd772"]])

export default __exports__